var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "other-params-form" },
    [
      _c("div", { staticClass: "params-section" }, [
        _c("div", { staticClass: "section-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("span", { staticClass: "section-header__count" }, [
            _vm._v("共 " + _vm._s(_vm.paramsList.length) + " 项"),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "params-panel" },
          [
            _vm.paramsList.length
              ? _c(
                  "el-table",
                  {
                    staticClass: "params-table",
                    attrs: {
                      data: _vm.paramsList,
                      border: "",
                      stripe: "",
                      size: "small",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "attrName",
                        label: "参数名",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "attrValue",
                        label: "参数值",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "展示到列表",
                        width: "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-checkbox", {
                                  model: {
                                    value: scope.row.showList,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "showList", $$v)
                                    },
                                    expression: "scope.row.showList",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4064189165
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "展示到标题",
                        width: "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-checkbox", {
                                  model: {
                                    value: scope.row.showTitle,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "showTitle", $$v)
                                    },
                                    expression: "scope.row.showTitle",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2083234575
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        width: "60",
                        align: "center",
                        "class-name": "col-action",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "delete-btn",
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDeleteParam(
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("\n              删除\n            ")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4234495321
                      ),
                    }),
                  ],
                  1
                )
              : _c("div", { staticClass: "params-empty" }, [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无商品参数，可点击下方按钮添加")]),
                ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-param-row" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "", icon: "el-icon-plus" },
                    on: { click: _vm.showAddParamDialog },
                  },
                  [_vm._v("\n          添加参数\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加参数",
            visible: _vm.addParamDialogVisible,
            width: "500px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addParamDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "paramForm",
              attrs: {
                model: _vm.newParam,
                "label-width": "100px",
                rules: _vm.paramRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "参数名", prop: "attrName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入参数名称" },
                    model: {
                      value: _vm.newParam.attrName,
                      callback: function ($$v) {
                        _vm.$set(_vm.newParam, "attrName", $$v)
                      },
                      expression: "newParam.attrName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "参数值", prop: "attrValue" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入参数值" },
                    model: {
                      value: _vm.newParam.attrValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.newParam, "attrValue", $$v)
                      },
                      expression: "newParam.attrValue",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "展示到列表" } },
                [
                  _c("el-checkbox", {
                    model: {
                      value: _vm.newParam.showList,
                      callback: function ($$v) {
                        _vm.$set(_vm.newParam, "showList", $$v)
                      },
                      expression: "newParam.showList",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "展示到标题" } },
                [
                  _c("el-checkbox", {
                    model: {
                      value: _vm.newParam.showTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.newParam, "showTitle", $$v)
                      },
                      expression: "newParam.showTitle",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addParamDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAddParam },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header__left" }, [
      _c("h3", [_vm._v("商品参数")]),
      _vm._v(" "),
      _c("span", { staticClass: "section-header__desc" }, [
        _vm._v("用于展示在商品详情页的自定义参数"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }